import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { animeList } from '@/mocks/anime';

export default function HotAnimeSection() {
  const { t } = useTranslation();
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
              {t('本季热播')}
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              {t('每周日更新')}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-500 hover:text-white text-foreground-600 transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-500 hover:text-white text-foreground-600 transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto scrollbar-hide pb-2"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {animeList.slice(0, 8).map((anime) => (
            <Link
              key={anime.id}
              to={`/anime/${anime.id}`}
              className="flex-shrink-0 w-[220px] md:w-[260px] group cursor-pointer"
            >
              <div className="relative rounded-lg overflow-hidden aspect-[3/4]">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  title={`${anime.title} - 樱花动漫`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 z-10">
                  <span
                    className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${
                      anime.status === '已完结'
                        ? 'bg-background-50/80 text-foreground-700'
                        : 'bg-primary-500/90 text-white'
                    }`}
                  >
                    {anime.status === '已完结' ? t('已完结') : `${t('更新至')}${anime.episodes}${t('话')}`}
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-4 pt-12">
                  <h3 className="text-white font-medium text-sm md:text-base mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
                    {anime.title}
                  </h3>
                  <p className="text-white/70 text-xs line-clamp-2">{anime.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}